
            const data = {"name":"icon-checkmark-medium","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M1.32 17.75a.74.74 0 011.05-1.04l8.61 8.61a.74.74 0 01-1.04 1.05l-8.62-8.62z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M10.98 26.37a.74.74 0 01-1.04-1.05l19.7-19.69a.74.74 0 011.04 1.05l-19.7 19.69z\"/>"}}
        
                module.exports = data
                